export { default } from './MarkForCupping';
